import React from "react";

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiHorizontalRule,
} from "@elastic/eui";

import IntroCards from "./featuresCGIToC";

export default function IntroHome() {
  return (
    <React.Fragment>
      <EuiSpacer />
      <EuiTitle size="m">
        <h1>UltraHD Series (2K+ 1440p & 4K 2160p) CGI List :: Features Menu</h1>
      </EuiTitle>
      <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup
        gutterSize="l"
        direction="column"
        style={{ margin: "0 7px" }}
      >
        <IntroCards />
      </EuiFlexGroup>
    </React.Fragment>
  );
}
